export enum ToastStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}
